export const homeTableTabs = [
  {
    id: "upcoming-orders",
    content: "Upcoming orders",
  },
  {
    id: "recent-cancellation",
    content: "Recent cancellation attempts",
  },
];
